import { z } from 'zod';
// Le login (OAuth ou PAT) ne collecte plus le token Jira — géré exclusivement via la modal
// Paramètres (SettingsModal.tsx, JiraCredentialsInput ci-dessous), qui seule possède
// jiraTokenEnc/jiraEmail/jiraBaseUrl désormais. Une reconnexion ne touche donc plus jamais
// ces champs, contrairement à l'ancienne politique "repartir de manquant sauf se souvenir".
export const CredentialsInput = z.object({
    gitlabToken: z.string().min(10),
});
// jiraBaseUrl optionnel : une chaîne vide/absente signifie "utiliser la valeur par défaut du
// serveur" (config.JIRA_BASE_URL) — résolu côté route (auth.ts, resolveJiraBaseUrl), pas ici.
export const JiraCredentialsInput = z.object({
    jiraToken: z.string().min(1),
    jiraBaseUrl: z.string().trim().optional(),
});
// Vérifie qu'une URL pointe vers une instance Jira réellement joignable, indépendamment du token
// (endpoint public /status, sans authentification) — voir services/jira.ts, validateJiraBaseUrl.
// Distinct de la vérification combinée token+URL (JiraCredentialsInput ci-dessus) : utile quand
// l'utilisateur édite l'URL avant même d'avoir un token à saisir.
export const JiraBaseUrlInput = z.object({
    jiraBaseUrl: z.string().trim().min(1),
});
export const JiraBaseUrlVerifyResponse = z.object({
    valid: z.boolean(),
});
export const SessionDTO = z.object({
    userId: z.string(),
    email: z.string(),
    name: z.string().nullable(),
    avatarUrl: z.string().nullable(),
    hasGitlab: z.boolean(),
    hasJira: z.boolean(),
    aiEnabled: z.boolean(),
    // Rubrique "Modèles Claude" de la modal Paramètres (édition des prix) — voir
    // AI_PRICING_ALLOWED_EMAILS, apps/api/src/config.ts.
    aiPricingAdmin: z.boolean(),
});
export const JiraTokenVerifyResponse = z.object({
    valid: z.boolean(),
});
export const JiraTokenDTO = z.object({
    // Jamais le token lui-même : il ne quitte plus le serveur une fois enregistré (un XSS ou une
    // session volée ne doit pas pouvoir l'exfiltrer). Le client ne sait que s'il en existe un.
    hasToken: z.boolean(),
    // null quand il n'y a pas de token à valider (token absent) — distinct de false (présent mais
    // invalide/expiré).
    valid: z.boolean().nullable(),
    // URL Jira effectivement enregistrée pour ce compte (null si aucun credential Jira n'a jamais
    // été sauvegardé). defaultBaseUrl (config.JIRA_BASE_URL) sert de valeur de repli pour préremplir
    // le champ côté modal Paramètres tant que l'utilisateur n'a rien personnalisé.
    jiraBaseUrl: z.string().nullable(),
    defaultBaseUrl: z.string(),
});
// Même trio que Jira ci-dessus (Input/VerifyResponse/DTO), pour la clé API Claude par compte
// (User.claudeApiKeyEnc) — voir SettingsModal.tsx, rubrique Authentification.
export const ClaudeApiKeyInput = z.object({
    apiKey: z.string().min(1),
});
export const ClaudeApiKeyVerifyResponse = z.object({
    valid: z.boolean(),
});
export const ClaudeApiKeyDTO = z.object({
    // Même principe que JiraTokenDTO.hasToken : la clé n'est jamais renvoyée une fois enregistrée.
    hasKey: z.boolean(),
    valid: z.boolean().nullable(),
});
//# sourceMappingURL=auth.js.map